module.exports = __webpack_public_path__ + "img/boston.36ea14bb.jpg";